'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';

import styles from '@/styles/pages/login.module.scss';

interface LoginLayoutProps {
  children: React.ReactNode;
}

export const useBuildVersion = () => {
  const [buildVersion, setBuildVersion] = useState('?');

  useEffect(() => {
    fetch('/evois/version/build')
      .then((res) => res.json())
      .then((res) => setBuildVersion(res.BUILD_VERSION))
      .catch(() => setBuildVersion('?'));
  }, []);

  return buildVersion;
};

export const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
  const buildVersion = useBuildVersion();

  return (
    <div className={[styles['login-panel'], 'login-panel', 't-login-panel'].join(' ')}>
      <div className={[styles['login-form-container'], 'login-form-container', 't-login-form-container'].join(' ')}>
        <div className={[styles['login-logo-container'], 'login-logo-container', 't-login-logo-container'].join(' ')}>
          <Image
            className={[styles['login-logo'], 'login-logo', 't-login-logo'].join(' ')}
            alt="EvoIS logo"
            src="/evois/img/evois_logo.svg"
            width={311}
            height={125}
            priority
          />
        </div>

        {children}
      </div>

      <div className={[styles['version-info'], 'version-info', 't-version-info'].join(' ')}>
        <div className="left">Release: 2.9.2</div>
        <div className="right">Build: {buildVersion}</div>
      </div>
    </div>
  );
};
